import React from 'react';
import { connect } from 'react-redux';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import fetch, { fetchConfig } from '@/hooks/fetch';
import UserPanelContainer, { mapDispatchToProps, mapStateToProps } from '../components/UserPanelContainer';
import UserPanelAccordion from '../components/UserPanelAccordion';
import UserSummary from './UserSummary';

const UserPanelNarrow = ({
  canRead,
  category,
  code,
  exists,
  fetchData,
  isDirty,
  name,
  onChange,
  panels,
  readErrors,
  readStatus,
  updateErrors,
  updatePanels,
  url,
  updateProperties,
  user,
}) => {
  fetch.useFetchByCode(fetchData, category, code, readStatus, fetchConfig([], () => !user));
  return (
    <UserPanelContainer
      canRead={canRead}
      category={category}
      code={code}
      exists={exists}
      isDirty={isDirty}
      name={name}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={readStatus}
      url={url}
    >
      <div className="aridhia-user-panel-narrow">
        <EntitiesErrorMessages
          category={category}
          code={code}
          entities={['user', 'server']}
          entity="user"
          errors={updateErrors}
          onDismiss={(errors) => updateProperties(category, code, { updateErrors: errors })}
        />
        <UserSummary code={code} category={category} />
        <UserPanelAccordion
          category={category}
          code={code}
          panels={panels}
          updatePanels={updatePanels}
        />
      </div>
    </UserPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPanelNarrow);
